import { CommonModule }                   from '@angular/common';
import { NgModule }                       from '@angular/core';
import {
	NgbCollapseModule,
	NgbDropdownModule,
	NgbTooltipModule
}                                         from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule }                 from '@ng-select/ng-select';
import { PageBaseModule }                 from '@shared/bases/page-base/page-base.module';
import { ActionItemModule }               from '@shared/components/action-item/action-item.module';
import { AddressModule }                  from '@shared/components/address/address.module';
import { ButtonGroupModule }              from '@shared/components/button-group/button-group.module';
import { CheckboxModule }                 from '@shared/components/checkbox/checkbox.module';
import { ChipModule }                     from '@shared/components/chip/chip.module';
import { CodeEditorWindowModule }         from '@shared/components/code-editor/code-editor-window/code-editor-window.module';
import { ColorPickerModule }              from '@shared/components/color-picker/color-picker.module';
import { DatePickerModule }               from '@shared/components/date-picker/date-picker.module';
import { EntityActiveSortPropertyModule } from '@shared/components/entity-active-sort-property/entity-active-sort-property.module';
import { FileDropModule }                 from '@shared/components/file-drop/file-drop.module';
import { GroupModule }                    from '@shared/components/group/group.module';
import { LanguageSelectorModule }         from '@shared/components/language-selector/language-selector.module';
import { LinkItemModule }                 from '@shared/components/link-item/link-item.module';
import { ListEmptyResultModule }          from '@shared/components/list-empty-result/list-empty-result.module';
import { LoaderModule }                   from '@shared/components/loader/loader.module';
import { ParameterizedHtmlTextModule }    from '@shared/components/parameterized-html-text/parameterized-html-text.module';
import { ResultViewModule }               from '@shared/components/result/result-view/result-view.module';
import { SettingCardModule }              from '@shared/components/setting-card/setting-card.module';
import { StatusFlowModule }               from '@shared/components/status-flow/status-flow.module';
import { StatusTextModule }               from '@shared/components/status-text/status-text.module';
import { SvgModule }                      from '@shared/components/svg/svg.module';
import { TableModule }                    from '@shared/components/table/table.module';
import { TabsModule }                     from '@shared/components/tabs/tabs.module';
import { TabsetModule }                   from '@shared/components/tabset/tabset.module';
import { TagModule }                      from '@shared/components/tag/tag.module';
import { PageHeaderModule }               from '@shared/content-sections/page-header/page-header.module';
import { StickyContentModule }            from '@shared/content-sections/sticky-content/sticky-content.module';
import { DirectivesModule }               from '@shared/directives/directives.module';
import { ListOperationsListHeaderModule } from '@shared/list-operations/components/list-operations-list-header/list-operations-list-header.module';
import { ListOperationsModule }           from '@shared/list-operations/list-operations.module';
import { PipesModule }                    from '@shared/pipes/pipes.module';
import { SharedFormModule }               from '@shared/shared-form.module';
import { ClipboardModule }                from 'ngx-clipboard';
import { NgxPrintModule }                 from 'ngx-print';
import { UiSwitchModule }                 from 'ngx-ui-switch';

@NgModule( {
	imports: [],
	declarations: [],
	exports: [
		// Angular
		CommonModule,

		// Third Party
		ClipboardModule,
		NgbCollapseModule,
		NgbDropdownModule,
		NgbTooltipModule,
		NgSelectModule,
		NgxPrintModule,
		UiSwitchModule,

		// APP
		ActionItemModule,
		AddressModule,
		ButtonGroupModule,
		CheckboxModule,
		ChipModule,
		CodeEditorWindowModule,
		ColorPickerModule,
		DatePickerModule,
		EntityActiveSortPropertyModule,
		FileDropModule,
		GroupModule,
		LanguageSelectorModule,
		LinkItemModule,
		ListEmptyResultModule,
		ListOperationsListHeaderModule,
		ListOperationsModule,
		LoaderModule,
		PageBaseModule,
		PageHeaderModule,
		ParameterizedHtmlTextModule,
		ResultViewModule,
		SettingCardModule,
		SharedFormModule,
		StatusFlowModule,
		StatusTextModule,
		StickyContentModule,
		SvgModule,
		TableModule,
		TabsetModule,
		TabsModule,
		TagModule,

		// Directives
		DirectivesModule,

		// Pipes
		PipesModule
	]
} )
export class SharedModule {}
